<template>
  <div class="camera-recorder">
    <video
      id="cameraRecorder"
      class="video-js vjs-default-skin"
      playsinline
    ></video>
    <div class="camera-recorder__start-button" v-if="!hideRecordButton">
      <b-icon-stop-circle v-if="recording" @click="toggleRecord" />
      <b-icon-circle-fill v-else @click="toggleRecord" />
    </div>
    <div
      class="camera-recorder__select-file-wrapper"
      v-if="!selectedFile && !recording && !recordedFile"
    >
      <b-button
        variant="primary"
        class="select-file-link"
        size="sm"
        @click.prevent="$refs.fileInput.click()"
        >Select File</b-button
      >
      <input
        accept="video/*"
        type="file"
        class="d-none"
        ref="fileInput"
        @change="onChangeFile"
      />
    </div>
  </div>
</template>

<script>
import 'video.js/dist/video-js.css'
import 'videojs-record/dist/css/videojs.record.css'
import videojs from 'video.js'

import 'webrtc-adapter'

// required by videojs to record
// eslint-disable-next-line no-unused-vars
import Record from 'videojs-record/dist/videojs.record.js'

export default {
  props: {
    hideRecordButton: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      player: '',
      deviceReady: false,
      recording: false,
      selectedFile: null,
      recordedFile: null,
      options: {
        controls: true,
        autoplay: false,
        fluid: true,
        loop: false,
        width: 320,
        height: 240,
        bigPlayButton: true,
        controlBar: {
          volumePanel: false,
          fullscreenToggle: false,
          recordToggle: false,
        },
        plugins: {
          record: {
            audio: true,
            video: true,
            debug: false,
            maxLength: 5 * 60, // 5 minutes
          },
        },
      },
    }
  },
  mounted() {
    this.player = videojs('#cameraRecorder', this.options)

    this.player.record().getDevice()

    // device is ready
    this.player.on('deviceReady', () => {
      this.deviceReady = true
      // console.log('device is ready!')
    })

    // user clicked the record button and started recording
    this.player.on('startRecord', () => {
      this.recording = true
    })

    // user completed recording and stream is available
    this.player.on('finishRecord', () => {
      this.recording = false
      this.recordedFile = this.player.recordedData
      this.$emit('change', this.recordedFile)
    })

    this.player.on('error', (element, error) => {
      // console.warn(error)
    })

    this.player.on('deviceError', () => {
      // console.error('device error:', this.player.deviceErrorCode)
    })
  },
  methods: {
    toggleRecord() {
      if (!this.deviceReady) {
        return
      }
      if (this.recording) {
        this.stopRecording()
      } else {
        this.startRecording()
      }
    },
    startRecording() {
      this.player.record().start()
    },
    stopRecording() {
      this.player.record().stop()
    },
    onChangeFile(e) {
      this.selectedFile =
        (e.target.files && e.target.files.length && e.target.files[0]) || null
      this.$emit('change', this.selectedFile, true)
    },
  },
  watch: {
    selectedFile(value) {
      const videoPlayers = document.getElementsByClassName('video-js')

      for (let i = 0; i < videoPlayers.length; i++) {
        videoPlayers[i].classList[value ? 'add' : 'remove']('d-none')
      }
    },
  },
  beforeDestroy() {
    if (this.player) {
      this.player.dispose()
    }
  },
}
</script>

<style lang="scss">
@import '../../assets/scss/abstract/variables';

.camera-recorder {
  position: relative;
}

.camera-recorder__start-button svg {
  color: $brand;
  width: 50px;
  height: 50px;
  position: absolute;
  bottom: 20px;
  right: 50%;
  transform: translateX(50%);
  cursor: pointer;
}

.select-file-link {
  position: absolute;
  bottom: 25px;
  right: 50%;
  transform: translateX(-50%);
}
</style>
